import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import { Card, Tooltip } from "antd";
import Icon from "../components/customIcons/customIcons";
import { DEFAULT_IMAGE_CARD, TEMPLATE } from "../config/Config";
import { STATUS_CODES } from "../config/StatusCode";
import { MESSAGES } from "../config/Message";
import { langs } from "../config/localization";
import {
  addToCartAPI,
  removeToRetailWishlist,
  addToRetailWishList,
  loadingAction,

  openLoginModel,
  setFavoriteItemId,
  classifiedWishlistAction,
  removeToWishList,
} from "../store/actions/index";
import {
  getClassifiedDetailPageRoute,
  getRetailDetailPageRoute,
  getDetailPageRoute,
} from "../common/getRoutes";
import { salaryNumberFormate, capitalizeFirstLetter } from "../components/common";
import ContactModal from "../components/classified-templates/common/modals/ContactModal";
import CartModel from "../components/retail/retail-cart/CartModel";
import { ReactComponent as RatingStarIcon } from "../assets/images/new-images/rating-star.svg"
import { ReactComponent as LocationPinIcon } from "../assets/images/new-images/location-pin.svg"
import { slugify } from "../common/Methods";
import { replaceImageURL } from '../common/Navigation';

class DetailCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flag: false,
      favoriteItem: [],
      is_favourite: false,
      visible: false,
      openCartModel: false,
    };
  }

  /**
   * @method componentDidMount
   * @description called before mounting the component
   */
  componentDidMount() {
    const { data } = this.props;
    this.setState({ is_favourite: data.wishlist ? true : false });
  }

  onSelection = (data) => {
    const { favoriteItem, is_favourite } = this.state;
    const { isLoggedIn, loggedInDetail, retail } = this.props;
    if (isLoggedIn) {
      if (data.wishlist === 1 || is_favourite) {
        const requestData = {
          user_id: loggedInDetail.id,
          classifiedid: data.classifiedid ? data.classifiedid : data.id,
        };
        this.props.loadingAction(true);
        if (retail) {
          this.props.removeToRetailWishlist(requestData, (res) => {
            this.props.loadingAction(false);
            if (res.status === STATUS_CODES.OK) {
              // toastr.success(langs.success, res.data.msg)
              toastr.success(langs.success, MESSAGES.REMOVE_WISHLIST_SUCCESS);
              // this.props.callNext()
              this.setState({ is_favourite: false });
            }
          });
        } else {
          this.props.removeToWishList(requestData, (res) => {
            this.props.loadingAction(false);
            if (res.status === STATUS_CODES.OK) {
              // toastr.success(langs.success, res.data.msg)
              toastr.success(langs.success, MESSAGES.REMOVE_WISHLIST_SUCCESS);
              // this.props.callNext()
              this.setState({ is_favourite: false });
            }
          });
        }
      } else {
        const requestData = {
          user_id: loggedInDetail.id,
          classifiedid: data.classifiedid ? data.classifiedid : data.id,
        };
        this.props.loadingAction(true);
        if (retail) {
          this.props.addToRetailWishList(requestData, (res) => {
            this.props.loadingAction(false);
            this.setState({ flag: !this.state.flag });
            if (res.status === STATUS_CODES.OK) {
              // toastr.success(langs.success, res.data.msg)
              toastr.success(langs.success, MESSAGES.ADD_WISHLIST_SUCCESS);
              // this.props.callNext()
              this.setState({ is_favourite: true });
            }
          });
        } else {
          this.props.classifiedWishlistAction(requestData, (res) => {
            this.props.loadingAction(false);
            this.setState({ flag: !this.state.flag });
            if (res.success) {
              // toastr.success(langs.success, res.data.msg)
              toastr.success(langs.success, MESSAGES.ADD_WISHLIST_SUCCESS);
              // this.props.callNext()
              this.setState({ is_favourite: true });
            }
          });
        }
      }
    } else {
      this.props.openLoginModel();
    }
  };

  /**
   * @method selectTemplateRoute
   * @description navigate to detail Page
   */
  selectTemplateRoute = (el) => {
    let cat_id =
      this.props.match.params.categoryId !== undefined
        ? this.props.match.params.categoryId
        : el.parent_categoryid !== undefined
          ? el.parent_categoryid
          : el.id;
    const { retail } = this.props;
    let catName = el.catname;
    let classifiedId = el.classifiedid;
    let templateName = el.template_slug;
    let path = "";
    if (retail) {
      path = getRetailDetailPageRoute(cat_id, catName, classifiedId);
      this.setState({ redirect: path });
    }
    if (templateName === TEMPLATE.GENERAL) {
      path = getClassifiedDetailPageRoute(
        templateName,
        cat_id,
        catName,
        classifiedId
      );
      this.setState({ redirect: path });
    } else if (templateName === TEMPLATE.JOB) {
      path = getClassifiedDetailPageRoute(
        templateName,
        cat_id,
        catName,
        classifiedId
      );
      this.setState({ redirect: path });
    } else if (templateName === TEMPLATE.REALESTATE) {
      path = getClassifiedDetailPageRoute(
        templateName,
        cat_id,
        catName,
        classifiedId
      );
      this.setState({ redirect: path });
    }
    // window.open(path, "_blank")
  };


  /**
   * @method contactModal
   * @description contact model
   */
  contactModal = (data) => {
    const { retail, isLoggedIn, loggedInDetail } = this.props;
    if (isLoggedIn) {
      if (retail) {
        if (data.quantity) {
          let requestData = {
            ship_cost: 0,
            available_qty: data.quantity,
            qty: 1,
            classified_id: data.classifiedid
              ? data.classifiedid
              : data.parent_categoryid,
            user_id: loggedInDetail.id,
          };
          this.props.addToCartAPI(requestData, (res) => {
            if (res.status === 200) {
              if (res.data.status === 1) {
                toastr.success(langs.success, MESSAGES.AD_TO_CART);
                this.setState({ openCartModel: true });
              } else {
                toastr.error(langs.error, res.data.msg);
              }
            }
          });
        } else {
          toastr.warning("This product is out of stock");
        }
      } else {
        this.setState({ visible: true });
      }
    } else {
      this.props.openLoginModel();
    }
  };

  /**
   * @method render
   * @description render component
   */
  render() {
    const { data, col, retail, theme } = this.props;

    const { openCartModel, visible, is_favourite } = this.state;
    let path = (theme === 'retail') ? getDetailPageRoute(theme, data.title, data.id)
      : (theme === 'booking') ? getDetailPageRoute(theme, data?.business_profile?.business_name ?? data.name, data.id)
        : ''

    if (theme === TEMPLATE.CLASSIFIED) {
      path = getClassifiedDetailPageRoute(
        slugify(data?.category?.name ?? ''),
        data?.category?.id,
        data?.category?.name,
        data?.id
      );
    }
    let extraTag = "",
      style = "";
    if (data.featured_classified === 1) {
      extraTag = "Featured";
      style = "feature-tag";
    } else if (data.is_premium === 1) {
      extraTag = "Premium";
      style = "premium-tag";
    }
    let minSal = 0;
    let maxSal = 0;
    let salType = '';
    if (theme === TEMPLATE.CLASSIFIED && data?.category?.name === "Jobs") {
      if (data.classified_salary && Array.isArray(data.classified_salary)) {
        minSal = data.classified_salary.find((obj) => obj.name === "minimum_salary")?.pivot?.attr_value;
        maxSal = data.classified_salary.find((obj) => obj.name === "maximum_salary")?.pivot?.attr_value;
        salType = data.classified_salary.find((obj) => obj.name === "salary_type")?.pivot?.attr_value;
      }
    }
    return (
      <div className='productItem'>
        <Card
          bordered={false}
          className={""}
          cover={
            <>
              <Link to={path}>
                {extraTag ? (
                  <div className={`card-tag ${style}`}>
                    <strong>{extraTag}</strong>
                  </div>
                ) : (
                  ""
                )}
                <img
                  src={
                    data?.product_image
                      ?  replaceImageURL(data?.product_image, 300, 300)
                      : data?.company_logo
                        ? replaceImageURL(data?.company_logo, 300, 300)
                        : data?.image
                          ? replaceImageURL(data?.image, 300, 300)
                          : DEFAULT_IMAGE_CARD}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = DEFAULT_IMAGE_CARD;
                  }}
                  style={{ cursor: "pointer" }}
                  alt={data && data.title ? data.title : ""}
                />
              </Link>
              {
                this.props.page === 'home' ?
                  <>
                    <div className="productCart">
                      <Icon
                        icon={theme === TEMPLATE.GENERAL ||
                          theme === TEMPLATE.JOB ||
                          theme === TEMPLATE.REALESTATE
                          ? "email" : "cart"
                        }
                        size="20"
                        onClick={() => this.contactModal(data)}
                      />
                    </div>
                    <div className="productWishlist">
                      <Icon
                        icon={is_favourite ? "wishlist-fill" : "wishlist"}
                        className={is_favourite ? "active" : ""}
                        size="20"
                        onClick={() => this.onSelection(data)}
                      />
                    </div>
                  </> : ''
              }

            </>

          }

        >
          {theme === 'retail'
            ? <>

              {data && data.title !== undefined ?
                <Link to={path} className="productTitle">
                  <Tooltip placement="topLeft" title={data && capitalizeFirstLetter(data.title)} overlayClassName="titleTooltip">
                    {data && capitalizeFirstLetter(data.title.substring(0, 48))}{data.title.length > 48 ? "..." : ""}
                  </Tooltip>
                </Link>
                : ""}

              <div className='price-box' >
                {data.category !== langs.bookingSubCategory.spa && (
                  <Link to={path} className='price'>
                    {data && data.price !== undefined
                      ? `AU$${salaryNumberFormate(parseInt(data.price))}`
                      : ""}
                  </Link>
                )}
              </div>

              <div className='category-box'>

                <div className="category-name">
                  {data && data.category ? data.category.name ? data.category.name : data.category : ""}
                </div>
                <div className='rate-section'>
                  {data.average_rating ? (
                    <>
                      <RatingStarIcon /> {`${parseInt(data.average_rating)}.0`}
                    </>
                  ) : (
                    'No reviews'
                  )}
                </div>
              </div>

            </>
            : ""
          }

          {!this.props.retail ?
            <>

              <Link to={path}>
                <div className="title"
                >
                  {data && data.title !== undefined
                    ? capitalizeFirstLetter(data.title)
                    : ""}
                </div>
              </Link>

              <Link to={path}>
                <div
                  className="price-box"
                  align="middle"
                  onClick={() => this.selectTemplateRoute(data)}
                >
                  <div className="price">
                    {data?.category?.name === "Jobs" ? (
                      `AU$${salaryNumberFormate(
                        parseInt(minSal)
                      )}-${salaryNumberFormate(parseInt(maxSal))}`
                    ) : !data.is_ad_free && !data.is_sold ? (
                      `AU$${salaryNumberFormate(parseInt(data.price))}`
                    ) : (
                      <div className="no-price">Free</div>
                    )}
                    {data.is_ad_free ? "Free" : ""}
                    {data.is_sold === 1 ? "Sold" : ""}
                  </div>
                </div>
              </Link>





              <Link to={path}>
                <div
                  className="category-box"
                  //onClick={() => this.selectTemplateRoute(data)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="category-name">
                    {data?.sub_category?.name ? data?.sub_category?.name : data?.category?.name}
                  </div>


                  {theme === 'retail' ? (
                    <div className="rate-section">
                      {data.average_rating ? (<><RatingStarIcon /> {data.average_rating}</>) : "No reviews"}
                    </div>
                  ) : ''}
                  {theme === langs.modules.classified ?
                    <>
                      <div className="location-name">
                        {data.location && data.location !== "N/A" && (
                          <LocationPinIcon />
                        )}
                        {/* {data.cityname && data.cityname !== 'N/A' ? data.cityname : ''} */}
                        <span>{data.location && data.location !== 'N/A' ? data.location : ''}</span>
                      </div>
                    </> : ''
                  }
                </div>
              </Link>

              {theme === langs.modules.classified ? data.tagIcon && (
                <div
                  className="productTag"
                >
                  {data.tagIcon}
                </div>
              ) : ''}
            </>
            : ""
          }
        </Card>
        {visible && (
          <ContactModal
            visible={visible}
            onCancel={() => this.setState({ visible: false })}
            classifiedDetail={data}
            receiverId={data.classified_users ? data.classified_users.id : ""}
            classifiedid={data.classifiedid}
          />
        )}
        {openCartModel && (
          <CartModel
            visible={openCartModel}
            onCancel={() => this.setState({ openCartModel: false })}
            title={data ? data.title : ""}
            price={data ? data.price : ""}
            image={
              data && data.imageurl !== undefined && data.imageurl !== null
                ? data.imageurl
                : DEFAULT_IMAGE_CARD
            }
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  const { auth, common } = store;
  const { isOpenLoginModel, favoriteId } = common;
  return {
    isLoggedIn: auth.isLoggedIn,
    loggedInDetail: auth.loggedInUser,
    isOpenLoginModel,
    favoriteId,
  };
};

export default connect(mapStateToProps, {
  addToCartAPI,
  removeToRetailWishlist,
  addToRetailWishList,
  loadingAction,

  openLoginModel,
  setFavoriteItemId,
  classifiedWishlistAction,
  removeToWishList,
})(withRouter(DetailCard));
